import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import ErrorMessage from 'components/core/error_message';
import { useBooleanState } from 'hooks/useBooleanState';
const CODE_LENGTH = 6;
const ALLOWED_KEYS = new Set(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Home', 'End']);
const wrapperCss = "w3pxz7z";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'label';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const cursorHiderCss = "c29r01z";
const CursorHider = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(cursorHiderCss, props.className)} />;
});
const virtualCaretCss = "v1y5twua";
const VirtualCaret = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(virtualCaretCss, props.className)} />;
});
const displayWrapperCss = "dpz21md";
const DisplayWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(displayWrapperCss, props.className)} />;
});
const displayFilledCss = "dwslcrw";
const displayIsErrorCss = "d14e32vo";
const displayCss = "d1p0g0sp";
const Display = forwardRef((props, ref) => {
  const {
    filled,
    isError,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(displayCss, {
    [displayFilledCss]: filled,
    [displayIsErrorCss]: isError
  }, props.className)} />;
});
const inputBoxCss = "ikrsop2";
const InputBox = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(inputBoxCss, props.className)} />;
});
const inputCss = "i784yup";
const Input = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'input';
  return <Component ref={ref} {...restProps} className={classNames(inputCss, props.className)} />;
});
const subTitleCss = "s1bu8ntr";
const SubTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subTitleCss, props.className)} />;
});
const fieldBlockCss = "fsazdi5";
const FieldBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fieldBlockCss, props.className)} />;
});
const CELLS = Array.from({
  length: CODE_LENGTH
}, (_, index) => index);
export const SMSVerificationInput = ({
  error,
  value,
  onChange,
  onFocus
}) => {
  const [virtualCaret, showVirtualCaret, hideVirtualCaret] = useBooleanState(false);
  const digits = value.split('');
  const showCaret = digits.length === CODE_LENGTH && virtualCaret;
  const handleKeyPress = e => {
    if (!ALLOWED_KEYS.has(e.key)) {
      e.preventDefault();
    }
  };
  const handleOnChange = e => {
    const newValue = e.target.value.replace(/\D/g, '');
    onChange(newValue, newValue.length === CODE_LENGTH);
  };
  return <FieldBlock>
      <Wrapper>
        <SubTitle>{I18n.t('publisher.workflows.actions.sms.enter_code')}</SubTitle>
        <InputBox>
          <Input type="text" value={value} maxLength={CODE_LENGTH} onKeyPress={handleKeyPress} onChange={handleOnChange} onSelect={e => {
          if (e.target.selectionStart === CODE_LENGTH && e.target.selectionEnd === CODE_LENGTH) {
            showVirtualCaret();
          } else {
            hideVirtualCaret();
          }
        }} onFocus={onFocus} />
          <DisplayWrapper>
            {CELLS.map(index => <Display key={index} filled={Boolean(digits[index])} isError={!!error}>
                  {showCaret && index === CODE_LENGTH - 1 && <VirtualCaret />}
                </Display>)}
            <CursorHider />
          </DisplayWrapper>
        </InputBox>
        <ErrorMessage message={error} />
      </Wrapper>
    </FieldBlock>;
};

require("./sms_verification_input.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./sms_verification_input.js");